import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    notYetTopupEligilbeAlertText: {
        id: '_.outstanding_view.notYetTopupEligilbeAlertText',
        defaultMessage:
            " You can request more funds once you've repaid {amount} - "
    },
    notYetTopupEligilbeAlertDescription: {
        id: '_.outstanding_view.notYetTopupEligilbeAlertDescription',
        defaultMessage:
            " You've passed our eligibility checks but your approval will still be subject to a credit review"
    },
    notTopupEligilbeText: {
        id: '_.outstanding_view.notTopupEligilbeText',
        defaultMessage: "Sorry, you can't request more funds at the moment"
    },
    notTopupEligilbeDescription: {
        id: '_.outstanding_view.notTopupEligilbeDescription',
        defaultMessage:
            "isn't eligible for additional funding - feel free to give your account manager a call if you'd like to know more."
    },
    notTopupEligilbeCTAText: {
        id: '_.outstanding_view.notTopupEligilbeCTAText',
        defaultMessage: 'Get in touch'
    },
    topupDeclined: {
        id: '_.outstanding_view.topupDeclined',
        defaultMessage:
            'Sorry, we can’t approve you for more funds at the moment.'
    },
    preApprovedHeading: {
        id: '_.outstanding_view.preApprovedHeading',
        defaultMessage: "You've been automatically approved"
    },
    preApprovedDescription: {
        id: '_.outstanding_view.preApprovedDescription',
        defaultMessage: 'You can drawdown up to {amount} before {date}'
    },
    preApprovedCTA: {
        id: '_.outstanding_view.preApprovedCTA',
        defaultMessage: 'Choose how much'
    },
    preApprovedMoreFunds: {
        id: '_.outstanding_view.preApprovedMoreFunds',
        defaultMessage: 'Need more than {amount}?'
    },
    preApprovedMoreFundsCTA: {
        id: '_.outstanding_view.preApprovedMoreFundsCTA',
        defaultMessage: 'Request more funds'
    },
    backButtonCTA: {
        id: '_.outstanding_view.backButtonCTA',
        defaultMessage: 'Back'
    },
    requestMoreFundsHeading: {
        id: '_.outstanding_view.requestMoreFundsHeading',
        defaultMessage:
            "You're already approved for {amount}. Approval to more funds is subject to credit review."
    }
});
